/**
 * Import all module depenencies here.
 * Add commonly used modules to externals.
 */
import core from '../../../app.core.module.js';
import twofaProductAppConfig from './2fa.productapp.config.js';
import twofaProductAppRoute from './2fa.productapp.route.js';
import twofaProductAppController from './2fa.productapp.controller.js';

/**
 * This is the 2fa module. It it the entry point for this website.
 * Only declare the module's dependencies in this file.
 * @namespace 2fa Module
 */
angular.module('twofactorProductApp', [
  // Shared modules.
  core
])
// Register config.
.config(twofaProductAppConfig)
// Register route.
.config(twofaProductAppRoute)
// Register controller.
.controller('twofaProductAppController', twofaProductAppController);



export default 'twofactorProductApp';


// WEBPACK FOOTER //
// ./src/login/2fa/productapp/2fa.productapp.module.js